import { render } from "./HeroiconsSolidChevronLeft.vue?vue&type=template&id=62a57156"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChevronLeft.vue"]])

export default __exports__